import { APP_NAME } from "@constants/app.constants";
import CustomerListComponent from "@screens/customers/customer-list/customer-list.component";
import CustomerCreateComponent from "@screens/customers/customer-create/customer-create.component";
import CustomerEditComponent from "@screens/customers/customer-edit/customer-edit.component";

const customersRoutes = [
  {
    name: `Customers - ${APP_NAME}`,
    path: "/customers",
    icon: "layout",
    component: CustomerListComponent,
  },
  {
    name: `Create Customer - ${APP_NAME}`,
    path: "/customers/create",
    component: CustomerCreateComponent,
  },
  {
    name: `Edit Customer - ${APP_NAME}`,
    path: "/customers/edit",
    component: CustomerEditComponent,
  },
];

export default customersRoutes;
